import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import GlobalStyle from "./styles/Global";
import {
  DesktopViewContainer,
  TabletWrapper,
  TabletScreen,
} from "./styles/DesktopView";
import RootContainer from "./modules/rootContainer";
import "./styles/tailwind.generated.css";
import { isEmpty } from "lodash";
import Property from "./model/property";

const App = () => {
  useEffect(() => {
    const propertyUid = Property.getUid();
    const presets = Property.getPreset(propertyUid);
    const desktopContainer = document.getElementById("desktop-container");
    if (desktopContainer) {
      if (!isEmpty(presets.app_home_webapp_desktop_bg)) {
        desktopContainer.style.backgroundColor =
          presets.app_home_webapp_desktop_bg;
      }
    }
    const root = document.getElementById("root");
    const tabletContainer = document.getElementById("tablet-container");
    const wrapper = tabletContainer ? tabletContainer : root;
    if (wrapper) {
      if (!isEmpty(presets.app_home_global_background_color)) {
        wrapper.style.backgroundColor =
          presets.app_home_global_background_color;
      }
    }
  }, []);

  return (
    <Router>
      <DesktopViewContainer id="desktop-container">
        <TabletWrapper id="tablet-container">
          <TabletScreen id="tablet-screen">
            <RootContainer />
            <GlobalStyle />
          </TabletScreen>
        </TabletWrapper>
      </DesktopViewContainer>
    </Router>
  );
};

export default App;
